import React, {
  useEffect, useRef, useState, createRef
} from "react";
import BaseLayout from "layouts/base-layout";
import renderModules from "helpers/render-loadable-modules";
import PdpLayout from "components/pdp-layout";
import ProductReviews from "components/product-reviews";
import ProductContext from "services/product-context";
import ProductStructuredData from "components/seo/product";
import { lazyLoadVideos } from "helpers/lazyLoadVideos";
import * as styles from "../../components/pdp-layout/style.mod.scss";
import Image from "components/image";
export { Head } from "components/head";

const Product = ({ pageContext, path }) => {
  const { product, settings, meta, structured_data, reviewSummary } = pageContext;

  useEffect(() => {
    lazyLoadVideos();
  }, []);


  const layoutWrapperRef = createRef();
  const [showScroll, setShowScroll] = useState(false);

  const badgeRef = useRef();

  useEffect(() => {
    if (layoutWrapperRef.current) {
      window.onscroll = () => {
        let position = window.scrollY;
        if (position > 520) {
          setShowScroll(true);
        }
        else {
          setShowScroll(false);
        }
      };
    }
  }, []);

  const settingsFeatures = settings.Features.showSvg;
  const blueBadge = settings.Features.blueBadge;

  const pageData = {
    area: "product",
    group: product?.title,
    path,
    title: meta?.siteTitle
  };

  return (
    <BaseLayout
      data={settings}
      handle={path}
      pageSettings={product?.pageSettings}
      pageData={pageData}
    >
      <ProductStructuredData reviews={reviewSummary} meta={structured_data || {}} />
      <ProductContext.Provider value={product} linkTo={product?.content?.productLink}>
        <PdpLayout reviewSummary={reviewSummary} settings={settings} product={product} />
        {product?.modules && renderModules(product?.modules)}
      </ProductContext.Provider>
      <ProductReviews shopifyId={product?.shopifyId} cluster={product?.content?.cluster} variants={product?.clusterReviews}/>
      {blueBadge && <>
        {settingsFeatures && <>
          <div className={styles.container} ref={layoutWrapperRef}>
            {showScroll &&
              <div className={styles.mobileBadge} ref={badgeRef}>
                <Image image={blueBadge} alt={blueBadge?.alt} />
              </div>}
          </div>
          <div className={styles.desktopBadge} >
            <Image image={blueBadge} alt={blueBadge?.alt} />
          </div></>
        }</>
      }
    </BaseLayout>
  );
};

export default Product;